import { AttachmentFileDto } from "../../../services/dto";
import { FileDto } from "../lib";
import { ImageFileDto } from "../lib/imageFileDto";


export namespace FileHelper {
    export const extensionToMime: Record<string, string> = {
        ".png": "image/png",
        ".jpg": "image/jpeg",
        ".jpeg": "image/jpeg",
        ".gif": "image/gif",
        ".bmp": "image/bmp",
        ".webp": "image/webp",
    };

    export const FileToImageFileDto = async ( file: File  ): Promise<ImageFileDto> => {
        const base64 = await new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const result = reader.result as string;
                const base64Content = result.split(",")[1];
                resolve(base64Content);
            };
            reader.onerror = () => reject(reader.error);
            reader.readAsDataURL(file);
        });

        const extension = `.${file.name.split(".").pop()?.toLowerCase() || ""}`;

        return {
            fileName: file.name,
            mimeType: file.type,
            content: base64,
            extension,
            imageSize: file.size,
        };
    };

    export const FileToAttachmentFileDto = async (file: File): Promise<AttachmentFileDto> => {
        const base64 = await new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const result = reader.result as string;
                const base64Content = result.split(",")[1];
                resolve(base64Content);
            };
            reader.onerror = () => reject(reader.error);
            reader.readAsDataURL(file);
        });

        return {
            fileName: file.name,
            mimeType: file.type,
            content: base64,
        };
    };

    export const FileToFileDto = async (file: File): Promise<FileDto> => {
        const base64 = await new Promise<string>((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const result = reader.result as string;
                const base64Content = result.split(",")[1];
                resolve(base64Content);
            };
            reader.onerror = () => reject(reader.error);
            reader.readAsDataURL(file);
        });

        return {
            fileName: file.name,
            mimeType: file.type,
            content: base64,
        };
    };

    export const FileToBase64String = ({ image, }: { image: ImageFileDto; }): string => {
        const ext = image.extension?.toLowerCase();
        const mime = (ext && extensionToMime[ext]) || image.mimeType || "application/octet-stream";

        return `data:${mime};base64,${image.content}`;
    };

    export const AttachmentToBase64String = ({ image, }: { image: AttachmentFileDto; }): string => {
        const ext = image.extension?.toLowerCase();
        const mime = (ext && extensionToMime[ext]) || image.mimeType || "application/octet-stream";

        return `data:${mime};base64,${image.content}`;
    };

    export function downloadFile(url : string, filename: string) {
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    export function exportFile(url: string, filename: string) {
        const link = document.createElement("a");
        link.href = url;
        link.download = filename || "";
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

   export const downloadDocument = (content: string, dataType: string, fileName: string) => {
       const url = blobDocumentUrl(content, dataType);
       exportFile(url, fileName);
       window.URL.revokeObjectURL(url);
    };

    function blobDocumentUrl(data: string, dataType: string) {
        const arr = _base64ToArrayBuffer(data);
        var file = new Blob([arr], { type: dataType });
        return URL.createObjectURL(file);
    }

    function _base64ToArrayBuffer(base64: string) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    }

    //export const FileToBase64String = ({ image, }: { image: FileDto; }): string => {
    //    const ext = image.extension?.toLowerCase();
    //    const mime = (ext && extensionToMime[ext]) || image.mimeType || "application/octet-stream";

    //    return `data:${mime};base64,${image.content}`;
    //};
}
